<div class="sticky d-flex justify-content-between bg-white px-3 z-depth-half">
  <tree-view-tools [treeControl]="treeControl"></tree-view-tools>
</div>
<e-card2 class="m-3 z-depth-half dock-y" style="flex: 1">
  <div class="h-100 p-2" style="overflow: auto">
    <mat-tree
      class="m-2"
      style="background-color: transparent"
      [dataSource]="dataSource"
      [treeControl]="treeControl"
      >
      <mat-tree-node
        class="mat-tree-node"
        *matTreeNodeDef="let node; when: navigationItemFlatTreeConfig.hasNoContent"
        matTreeNodePadding
        >
        <tree-item-editor
          class="pl-4"
          placeholder="Nieuw item.."
          [value]="node.name"
          (save)="createSubMenu(node, $event)"
        ></tree-item-editor>
      </mat-tree-node>

      <mat-tree-node class="mat-tree-node py-2" *matTreeNodeDef="let node" matTreeNodePadding>
        <span style="width: 30px">
          @if (treeControl.isExpandable(node)) {
            <e-tree-item-expand-icon
              matTreeNodeToggle
            [class.text-danger]="
              node.navigationItem.hasDescendantThatShouldBeSynced ||
              node.navigationItem.descendantIsIncompatibleWith(app)
            "
              [expanded]="treeControl.isExpanded(node)"
            ></e-tree-item-expand-icon>
          }
        </span>

        <div
          [class.clicktrough-tree-item]="node.navigationItem.isClickTroughPage"
          [ngClass]="{
            'drop-above': navigationItemDragger.isDraggedAbove(node),
            'drop-below': navigationItemDragger.isDraggedBelow(node),
            'drop-center': navigationItemDragger.isDraggedCenter(node)
          }"
          class="hover-pointer d-flex"
          [class.active-item]="node === activeNode || node.entered"
          [draggable]="node.navigationItem.canBeChangedPosition && !app.shouldBeSynced"
          (dragstart)="handleDragStart($event, node)"
          (dragover)="handleDragOver($event, node)"
          (drop)="handleDrop($event, node)"
          (dragend)="handleDragEnd()"
          cdkDropList
          (cdkDropListEntered)="onNewItemDragEnter(node)"
          (cdkDropListExited)="onNewItemDragLeave(node)"
          [id]="node.id"
          (cdkDropListDropped)="onNewItemDropped($event, node)"
          >
          @if (!node.editing) {
            <navigation-item-label
              [navigationItem]="node.navigationItem"
              >
              <e-dropdown-menu #dropdown class="ml-1">
                <ng-template eSlot="activator">
                  <button
                    rounded
                    eBtn
                    icon="ellipsis-v"
                    (click)="dropdown.toggleMenu()"
                    squared
                    size="sm"
                    textColor="primary-50"
                    color="highlight"
                  ></button>
                </ng-template>
                <ng-template eSlot="menu">
                  @if (!node.navigationItem.isRoot) {
                    <e-dropdown-menu-item
                      (click)="deleteNavigationItem(node)"
                      iconColor="danger"
                      icon="trash"
                      >
                      Verwijderen
                    </e-dropdown-menu-item>
                  }
                  <e-dropdown-menu-item icon="plus" (click)="insertSubmenu(node)">
                    Nieuw submenu
                  </e-dropdown-menu-item>
                  @if (node.navigationItem.isNameEditable) {
                    <e-dropdown-menu-item
                      (click)="editNode(node)"
                      icon="pen"
                      iconColor="primary"
                      >
                      Naam wijzigen
                    </e-dropdown-menu-item>
                  }
                  @if (!node.navigationItem.isMenu) {
                    <e-dropdown-menu-item
                      icon="cog"
                      iconColor="primary"
                      (click)="onConfigure(node)"
                      >
                      Instellingen
                    </e-dropdown-menu-item>
                  }
                </ng-template>
              </e-dropdown-menu>
            </navigation-item-label>
          } @else {
            <tree-item-editor
              placeholder="Bewerken..."
              [value]="node.navigationItem.name"
              (save)="saveName(node, $event)"
            ></tree-item-editor>
          }

        </div>
        @if (node.navigationItem.shouldBeSynced || !node.navigationItem.isCompatibleWith(app)) {
          <navigation-item-conflicts-indicator
            [app]="app"
            class="ml-2"
            [navigationItem]="node.navigationItem"
          ></navigation-item-conflicts-indicator>
        }
      </mat-tree-node>

      <span #emptyItem></span>
    </mat-tree>
  </div>
</e-card2>

<e-dialog
  [(open)]="showConfigureNavigationItemDialog"
  [title]="'Configureer ' + nodeToConfigure?.navigationItem.name"
  size="lg"
  >
  <ng-template>
    <navigation-item-configurator
      (cancel)="closeConfigurationDialog()"
      (ready)="closeConfigurationDialog()"
      [navigationItem]="nodeToConfigure?.navigationItem"
    ></navigation-item-configurator>
  </ng-template>
</e-dialog>
